<h2 mat-dialog-title>Add New Equipment</h2>
<mat-dialog-content>
  <div [formGroup]="form" class="flex flex-col gap-y-6">
    <mat-form-field [testId]="testIds.EQUIPMENT_NAME">
      <mat-label>Equipment name</mat-label>
      <input
        matInput
        placeholder="Make / model number"
        formControlName="name"
      />
    </mat-form-field>
    <mat-form-field [testId]="testIds.SERIAL_NUMBER">
      <mat-label>Serial number</mat-label>
      <input
        matInput
        placeholder="Serial number"
        formControlName="serial_number"
      />
    </mat-form-field>
  </div>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button
    mat-flat-button
    mat-dialog-close
    [testId]="testIds.CANCEL_ADD_EQUIPMENT"
  >
    Cancel
  </button>
  <button
    mat-flat-button
    [disabled]="form.invalid"
    (click)="save()"
    [testId]="testIds.SAVE_EQUIPMENT"
  >
    Add
  </button>
</div>
